import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Home } from "./pages/Home";
import { Cases } from "./pages/Cases";
import { Events } from "./pages/Events";
type AppProps = {
  showReviewNotes?: boolean;
  eventsState?: "upcoming" | "empty";
};
function PagePosition() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    requestAnimationFrame(() => {
      if (hash) {
        const target = document.getElementById(decodeURIComponent(hash.slice(1)));
        target?.scrollIntoView({
          behavior: "auto",
          block: "start"
        });
        if (target?.hasAttribute("tabindex")) target.focus({
          preventScroll: true
        });
      } else window.scrollTo(0, 0);
    });
  }, [pathname, hash]);
  return null;
}
export function App({
  showReviewNotes = true,
  eventsState = "upcoming"
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="23vkvggucm9l8">
      <PagePosition data-id="element-1" data-mp="23w4ey1znd61d" />
      <Routes data-id="element-2" data-mp="23utcc5hxu4bu">
        <Route path="/biker-lawsuit-awards-settlements/*" element={<Cases data-id="element-4" data-mp="3ikqytzf4l45q" />} data-id="element-3" data-mp="23v2uj6wqr76z" />
        <Route path="/cases/*" element={<Cases data-id="element-6" data-mp="3ii4sg33z0up3" />} data-id="element-5" data-mp="3ijfwm41bw4gq" />
        <Route path="/events/*" element={<Events data-id="element-8" data-mp="3mkhou0wtvg97" />} data-id="element-7" data-mp="3mlayb9n68jv1" />
        <Route path="*" element={<Home showReviewNotes={showReviewNotes} showEmptyEvents={eventsState === "empty"} data-id="element-10" data-mp="3mj6jhwnqi0fz" />} data-id="element-9" data-mp="3mjq27fl7ksv2" />
      </Routes>
    </BrowserRouter>;
}